import { Skeleton as AntSkeleton, SkeletonProps } from 'antd';

export const Skeleton = AntSkeleton;

export type { SkeletonProps };
